import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slice/userSlice'
import permissionReducer from './slice/permissionSlice';
import sidebarMenuReducer from './slice/sidebarMenuSlice';
import customerRechargeUiReducer from './slice/customerRechargeUiSlice';
import applyCouponCodeReducer from './slice/applyCouponCodeSlice';
import fetchPlantsReducer from './slice/fetchPlantsSlice';
import fetchCustomerListReducer from './slice/fetchCustomerListSlice';
import createCashPaymentReducer from './slice/createCashPaymentSlice';
import calculateRechargeAmountReducer from './slice/calculateRechargeAmountSlice';
import fetchCashRechargeDetailsReducer from './slice/fetchCashRechargeDetailsSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    permissions: permissionReducer,
    sidebarMenu: sidebarMenuReducer,
    customerRechargeUi: customerRechargeUiReducer,
    applyCouponCode: applyCouponCodeReducer,
    fetchPlants: fetchPlantsReducer,
    fetchCustomerList: fetchCustomerListReducer,
    createCashPayment: createCashPaymentReducer,
    calculateRechargeAmount: calculateRechargeAmountReducer,
    fetchCashRechargeDetails: fetchCashRechargeDetailsReducer,
  },
});

export type StoreState = ReturnType<typeof store.getState>;

